<script lang="ts" setup>
  import HostErrorMessage from './HostErrorMessage.vue';
</script>

<template>
  <HostErrorMessage title="Spotify Premium required">
    <p>To host a Songstar game, your Spotify account needs Spotify Premium, since Spotify only plays songs for it.</p>
    <ol>
      <li>Upgrade the Spotify account to Premium, or sign in with a Premium account</li>
      <li>Try signing in again</li>
    </ol>
  </HostErrorMessage>
</template>
